export * from './KeytipData';
//# sourceMappingURL=index.js.map